import UtilsSchema from "@repoflow/schema/utils";

import {
  orgId,
  pageId,

  title,
  slug,
  body,
  createdAt,
  updatedAt
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/Page",
    type: "object",
    properties: {
      orgId,
      pageId,
      title,
      slug,
      body,
      createdAt,
      updatedAt
    }
  },
  {
    id: "/Public/Page/Create",
    type: "object",
    properties: {
      title,
      slug,
      body,
    },
    // Non-empty on purpose. An empty `required` array is what made assertValid
    // unable to reject anything in the project this shape came from (A9 in
    // docs/datum-api.md). `title` is already `String!` on PageInputCreate, so
    // this cannot reject a request GraphQL would have accepted — it only stops
    // the model layer being reachable with less than the contract promises.
    required: ["title"],
  },
  {
    id: "/Public/Page/Update",
    type: "object",
    properties: {
      title,
      slug,
      body,
    },
    required: ["title"],
  },
];
